import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { GALLERY } from "@/lib/constants";
import { useReveal } from "@/hooks/use-reveal";

export default function Gallery({ full = false }) {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null);
  const r = useReveal();

  const items = full ? GALLERY : GALLERY.slice(0, 6);

  return (
    <section className={`py-20 sm:py-24 ${full ? "bg-white" : "bg-[#F8FAFC]"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={r.ref} className={r.className}>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
            <div>
              <span className="text-sm font-semibold uppercase tracking-widest text-[#0E7490]">Gallery</span>
              <h2 className="mt-2 font-display text-3xl sm:text-4xl md:text-5xl font-bold text-[#111827] leading-tight">
                Life at the counter
              </h2>
              <p className="mt-3 text-[#6B7280] max-w-2xl">
                Placeholder photography — please share original images of the counter, signboard and staff and we'll swap them in.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((src, i) => (
              <button
                key={i}
                onClick={() => { setActive(src); setOpen(true); }}
                className="group relative overflow-hidden rounded-2xl border border-[#E2E8F0] bg-white aspect-[4/3] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0057B8]"
                data-testid={`gallery-item-${i}`}
                aria-label={`Open image ${i + 1}`}
              >
                <img
                  src={src}
                  alt={`Gallery image ${i + 1}`}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </button>
            ))}
          </div>
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl bg-black/90 border-0 p-0 overflow-hidden">
          {active && (
            <img src={active} alt="Enlarged gallery" className="w-full h-auto max-h-[85vh] object-contain" />
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
